var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"doc-container"},[_c('div',{staticClass:"doc-label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticClass:"doc-content-scroll"},[_c('div',{staticClass:"doc-content",domProps:{"innerHTML":_vm._s(_vm.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }